import React, { Component } from 'react'
import './index.less'
import score from 'src/helper/score'

import Header from '../Header'
import Rank from '../Rank'


export default class extends Component {
  render() {
    const {
      isShow,
      rankList,
      myRank,
      headWear1,
      headWear2,
      headWear3,
      bigBg,
      bgColor1,
      bgColor2
    } = this.props
    const top1 = rankList[0]
    const top2 = rankList[1]
    const top3 = rankList[2]

    return (
      <div className='nt-rank-wrap' style={{ display: `${isShow ? "block" : "none"}` }}>
        <div className="nt-top-user" style={{ background: `linear-gradient(to bottom, ${bgColor1}, ${bgColor2})` }}>
          <div className="top-main" style={{ backgroundImage: `url(${bigBg})` }}>
            <div className="top1">
              <Header
                userOrRoom={"user"}
                userId={top1 && top1.uid}
                userAvatar={top1 && top1.avatarurl}
                scaleSize={1}
                headWear={headWear1}
              />
              <div className="name">{top1 && top1.nickname}</div>
              <div className="id">{top1 && top1.duid}</div>
              <div className="gold">{score(top1 && top1.val)}</div>
            </div>
            <div className="top23">
              <div className="top2">
                <Header
                  userOrRoom={"user"}
                  userId={top2 && top2.uid}
                  userAvatar={top2 && top2.avatarurl}
                  scaleSize={1}
                  headWear={headWear2}
                />
                <div className="name">{top2 && top2.nickname}</div>
                <div className="id">{top2 && top2.duid}</div>
                <div className="gold">{score(top2 && top2.val)}</div>
              </div>
              <div className="top3">
                <Header
                  userOrRoom={"user"}
                  userId={top3 && top3.uid}
                  userAvatar={top3 && top3.avatarurl}
                  scaleSize={1}
                  headWear={headWear3}
                />
                <div className="name">{top3 && top3.nickname}</div>
                <div className="id">{top3 && top3.duid}</div>
                <div className="gold">{score(top3 && top3.val)}</div>
              </div>
            </div>
          </div>
          {
            rankList && rankList.map((item, index) => {
              if (index > 2) {
                return (
                  <div className="nt-rank-list" key={index}>
                    <Rank
                      userOrRoom={"user"}
                      userId={item && item.uid}
                      order={item.rank}
                      avatar={item.avatarurl}
                      name={item.nickname}
                      id={item.duid}
                      gold={item.val} />
                  </div>
                )
              }
            })
          }
          <div className="nt-myrank">
            <Rank
              userOrRoom={"user"}
              userId={myRank && myRank.uid}
              order={myRank && myRank.rank || ''}
              avatar={myRank && myRank.avatarurl || ''}
              name={myRank && myRank.nickname || ''}
              id={myRank && myRank.duid || ''}
              gold={myRank && myRank.val || ''} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/RankPart/index.js